
// TODO: REFACTOR
import { Component, Vue, Prop } from "vue-property-decorator";
import EmployeeService from "@/services/employee.service";
import RatingService from "@/services/rating.service";
import { mapState } from "vuex";
import { format as phoneFormatter } from "@/utils/phone.util";
import { OfficeDto } from "@/types/office.type";
import { UserDetailDto } from "@/types/user.type";

@Component({
  computed: {
    ...mapState("Shift", 
    [
      "selectedOffice", 
    ]),
  }
})
export default class EmployeeDetails extends Vue {
  @Prop() employeeKey!: { userId: number, practiceId: number };
  @Prop({ default: undefined }) officeId!: number | undefined;
  @Prop() isVisible!: boolean;

  selectedOffice!: OfficeDto;
  details: UserDetailDto | null = null;
  isBlocked = false;
  loading = false;
  phoneFormatter = phoneFormatter;

  fields = [
    { key: 'entryDate', label: 'Date', sortable: false, thClass: 'font-gray', tdClass: 'font-gray' },
    { key: 'office', label: 'Office', sortable: false, thClass: 'font-gray', tdClass: 'font-gray' },
    { key: 'rating', label: 'Rating', sortable: false, thClass: 'font-gray', tdClass: 'font-gray rating-col' },
    { key: 'comments', label: 'Comment', sortable: false, thClass: 'font-gray', tdClass: 'font-gray' }
  ];

  isFavorite: boolean | undefined;

  get showFavorite(): boolean {
    return this.officeId != null && !this.isBlocked;
  }

  get initials(): string {
    if (!this.details) {
      return "NN";
    }

    return `${this.details.firstName?.[0]}${this.details.lastName?.[0]}`;
  }

  get favoriteText(): string {
    if (!this.details) {
      return "";
    }

    return this.details.isFavorite ? "Remove from Favorites" : "Add to Favorites";
  }

  async toggleFavorite(): Promise<void> {
    if (!this.details) {
      return;
    }

    var newValue = !this.details.isFavorite;
    var verb = newValue ? "createOfficeFavorite" : "deleteOfficeFavorite";
    await this.$store.dispatch(`Shift/${verb}`, this.employeeKey.userId);
    this.details.isFavorite = newValue;
    this.$emit("change");
  }

  async showCertificate(certificateId: number): Promise<void> {    
    const blob = await EmployeeService.downloadCertificateAsync(certificateId);
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  }

  async mounted(): Promise<void> {
    this.loading = true;
    this.details = await RatingService.getUserDetailsAsync(this.employeeKey.practiceId, this.employeeKey.userId, this.officeId);
    this.isBlocked = await EmployeeService.getBlockStatusAsync(this.employeeKey.practiceId, this.employeeKey.userId);
    this.isFavorite = this.details?.isFavorite;
    this.loading = false;
  }

  async onBlockStatusChange(): Promise<void> {
    await EmployeeService.updateBlockStatusAsync(this.employeeKey.practiceId, this.employeeKey.userId);
    await this.$store.dispatch("DentalTemp/getAllEmployees");
    await this.$store.dispatch("DentalTemp/getOfficeEmployees", this.selectedOffice.id);
    
    this.details = await RatingService.getUserDetailsAsync(this.employeeKey.practiceId, this.employeeKey.userId, this.officeId);
    this.isFavorite = this.details.isFavorite;

    this.$emit("change");
  }

  closeModal(): void {
    if (!this.details) {
      this.$emit('update:isVisible', false);
 
      return;
    }

    if (this.isFavorite != this.details.isFavorite) {
      this.$emit('favoriteChange', { isFavorite: this.details.isFavorite, rating: this.details.rating });
    }

    this.$emit('update:isVisible', false);
  }
}
